import React from "react";
import AccessProviderNavbar from "../AccessProviderNavbar";

const PHARMACY_MENU_CONFIG = {
  pharmacy_authorizations: {
    path: "/authorizations",
    label: "Autorizaciones",
    icon: "fa-check-square-o",
  },
  "pharmacy_recipe-electronic": {
    path: "/electronic-recipes",
    label: "Recetas Digitales",
    icon: "fa-file-text-o",
  },
  "pharmacy_lastest-authorizations": {
    path: "/lastest-authorizations",
    label: "Últimas Autorizaciones",
    icon: "fa-history",
  },
  pharmacy_collaborators: {
    path: "/collaborators",
    label: "Colaboradores",
    icon: "fa-users",
  },
  "pharmacy_send-audit": {
    path: "/send-audit",
    label: "Auditoría de Reclamaciones",
    icon: "fa-clipboard",
  },
  "pharmacy_historical-transactions": {
    path: "/historical-transactions",
    label: "Histórico de Transacciones",
    icon: "fa-exchange",
  },
  "pharmacy_offers-ars": {
    path: "/offers-ars",
    label: "Ofertas por ARS",
    icon: "fa-tags",
  },
};

const NavbarPharmacy = (props) => (
  <AccessProviderNavbar
    {...props}
    menuConfig={PHARMACY_MENU_CONFIG}
    // Farmacia conserva el orden original de sus opciones (orden de los permisos).
    sortMenuAlphabetically={false}
    providerLabel="Farmacia"
    providerLogoAlt="logo farmacia"
  />
);

export default NavbarPharmacy;
